// extracted by mini-css-extract-plugin
export var quillEditor = "_ph-1";
export var variable = "_ph-0";